import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { API } from "../../config";
import { useAuth } from "../../context/AuthContext";

const TYPE_LABEL = { privacy: "Informativa Privacy", contract: "Contratto" };

export const LegalCoverageGapsAlert = ({ showLink = true }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [gaps, setGaps] = useState([]);
  const allowed = ["admin", "super_admin"].includes(user?.role);

  useEffect(() => {
    if (!allowed) return;
    axios.get(`${API}/admin/legal-documents/coverage-gaps`)
      .then((r) => setGaps(r.data?.gaps || []))
      .catch(() => setGaps([]));
  }, [allowed]);

  if (!allowed || gaps.length === 0) return null;

  return (
    <div className="mb-6 rounded-xl border border-red-500/40 bg-red-500/10 p-4 flex items-start gap-3" data-testid="legal-coverage-gaps-alert">
      <AlertTriangle className="text-red-400 flex-shrink-0 mt-0.5" size={20} />
      <div className="flex-1 min-w-0">
        <p className="text-white font-semibold text-sm">Documenti legali mancanti in paesi operativi</p>
        <p className="text-gray-400 text-xs mt-0.5">
          Paesi con concessionari o clienti senza documento attivo. Se manca l'Informativa Privacy, il cliente si blocca al passo 2. Se manca il contratto, viene usato il modello generico di riserva.
        </p>
        <ul className="mt-2 flex flex-wrap gap-2">
          {gaps.map((g) => (
            <li key={g.country} className="text-xs px-2.5 py-1 rounded-lg bg-black/40 border border-red-500/30 text-red-200" data-testid={`legal-gap-${g.country}`}>
              <span className="font-bold">{g.country}</span> ({g.language}): {g.missing.map((m) => TYPE_LABEL[m] || m).join(", ")}
            </li>
          ))}
        </ul>
      </div>
      {showLink && (
        <button
          onClick={() => navigate("/admin/legal")}
          className="btn-lojack-outline text-xs flex items-center gap-1 flex-shrink-0"
          data-testid="legal-gaps-go-btn"
        >
          Vai a Documenti Legali <ArrowRight size={14} />
        </button>
      )}
    </div>
  );
};
